import { FULL_PAGE_AGENTS, FULL_PAGE_AGENTS_PAGE } from '@townsquare/config/routes';
import { createGlobalRoute } from '@townsquare/router/create-route';
import { GlobalHomePageRoute } from '@townsquare/router/route-types';

export const agentsRoute: GlobalHomePageRoute = createGlobalRoute({
	exact: true,
	name: FULL_PAGE_AGENTS_PAGE,
	path: FULL_PAGE_AGENTS,
	layout: 'home',
	nav4Layout: 'expanded',
	featureGating: {
		gates: ['townsquare_enable_rovo_appification'],
		behavior: {
			type: 'enabled',
		},
	},
});
